export default "__VITE_ASSET__9d147eeb__"